<script setup lang="ts">
import { computed, defineEmits, defineProps, ref } from "vue";
import { useOperationStore } from "@/stores/operation";

import { getFileData } from "@/libs/tools";
// @typescript-eslint/no-unused-vars
import Drawer from "vue-simple-drawer";

const operationStore = useOperationStore();
const op = computed(() => operationStore.operationData);
const custom = computed(() => operationStore.customData);
const files = op.value?.files;
const logo = ref<{ filename: string; uri: string } | undefined>(undefined);
if (files) {
  logo.value = getFileData(files, "logo1");
}

const rules = computed(() => {
  return files ? getFileData(files, "reglement") : null;
});

const externallinks = ref<string | null>(null);
const store_visible = ref(false);

const politique = computed(() => {
  return files ? getFileData(files, "politique") : null;
});

const emit = defineEmits(["path", "update", "externallink"]);

const setPath = (path: string) => {
  emit("path", path);
  store_visible.value = false;
  externallinks.value = null;
  toggle();
};

const openLink = (link: { link: string; link_type: string }) => {
  if (link.link_type == "outside") {
    window.open(link.link, "_blank");
  }
  if (link.link_type == "inside") {
    store_visible.value = false;
    externallinks.value = link.link;
    emit("externallink", link.link);
  }
  toggle();
};

//const openStore = () => {
//  store_visible.value = true;
//};

// eslint-disable-next-line no-undef
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
  overquota: {
    type: Boolean,
    default: false,
  },
});

const links = ref<{ label: string; link: string; link_type: string }[]>(
  custom.value?.links ?? []
);

const open = ref(false);

const toggle = () => {
  open.value = !open.value;
};
</script>

<template>
  <div class="w-full absolute inset-0 z-30">
    <i
      @click="toggle"
      class="fa-solid cursor-pointer fa-bars absolute text-white text-2xl top-3 left-3"
    ></i>

    <Drawer @close="toggle" align="left" :closeable="true">
      <div v-if="open">
        <!--<img
          :src="logo?.uri"
          class="m-auto w-fit max-w-[50%] max-h-44 self-center object-contain mb-6"
        /> -->
        <ul class="px-4 w-full text-primary-text text-lg menumobile">
          <li class="flex-1 text-center">
            <ul class="justify-center gap-4 text-center">
              <li @click="setPath('login')">
                <i class="fa-solid fa-house"></i>
              </li>
              <li
                v-if="props.status === 'open' && !props.overquota"
                @click="setPath('register')"
              >
                {{ $t("header.register_link") }}
              </li>
              <li v-if="custom?.storemapper_id">
                <a @click="setPath('stores')">{{ $t("header.stores_link") }}</a>
              </li>
              <li v-if="links && links[0].label">
                <a @click="() => openLink(links[0])" v-html="links[0].label" />
              </li>
              <li v-if="links && links[1].label">
                <a @click="() => openLink(links[1])" v-html="links[1].label" />
              </li>
              <!-- <li v-if="rules && rules.uri">
                <a :href="rules?.uri" target="_blank">{{
                  $t("header.rules_link")
                }}</a>
              </li>
              <li v-if="politique && politique.uri">
                <a :href="politique?.uri" target="_blank">{{
                  $t("header.politiques_link")
                }}</a>
              </li>
              <li @click="setPath('mentions')">
                {{ $t("header.mentions_link") }}
              </li> -->
              <li @click="setPath('contact')">
                {{ $t("header.contact_link") }}
              </li>
            </ul>
          </li>
          <li>
            <ul class="flex justify-center gap-3 text-2xl mt-6">
              <li v-if="custom?.facebook_link">
                <a :href="custom?.facebook_link" target="_blank"
                  ><i class="fa-brands fa-facebook"></i
                ></a>
              </li>
              <li v-if="custom?.instagram_link">
                <a :href="custom?.instagram_link" target="_blank"
                  ><i class="fa-brands fa-instagram"></i
                ></a>
              </li>
              <li v-if="custom?.youtube_link">
                <a :href="custom?.youtube_link" target="_blank"
                  ><i class="fa-brands fa-youtube"></i
                ></a>
              </li>
              <li v-if="custom?.linkedin_link">
                <a :href="custom?.linkedin_link" target="_blank"
                  ><i class="fa-brands fa-linkedin"></i
                ></a>
              </li>
              <li v-if="custom?.pinterest_link">
                <a :href="custom?.pinterest_link" target="_blank"
                  ><i class="fa-brands fa-pinterest"></i
                ></a>
              </li>
              <li v-if="custom?.snapchat_link">
                <a :href="custom?.snapchat_link" target="_blank"
                  ><i class="fa-brands fa-snapchat"></i
                ></a>
              </li>
              <li v-if="custom?.twitter_link">
                <a :href="custom?.twitter_link" target="_blank"
                  ><i class="fa-brands fa-x-twitter"></i
                ></a>
              </li>
              <li v-if="custom?.discord_link">
                <a :href="custom?.discord_link" target="_blank"
                  ><i class="fa-brands fa-discord"></i
                ></a>
              </li>
              <li v-if="custom?.tiktok_link">
                <a :href="custom?.tiktok_link" target="_blank"
                  ><i class="fa-brands fa-tiktok"></i
                ></a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </Drawer>
  </div>
</template>

<style lang="scss">
.vue-simple-drawer {
  @apply z-50 w-5/6 h-full;
  background-color: white !important;
  background: white !important;
}

.menumobile ul li {
  @apply mb-4 cursor-pointer;
}

.rightleft,
.leftright {
  background-color: var(--secondary-color-background) !important;
}
</style>
